module.exports = __webpack_public_path__ + "img/illustration-working-mobile.ed3d1277.svg";